import { HttpTypes } from "@medusajs/types"

/**
 * Resolve a single stock-quantity number for a product.
 *
 * Priority:
 *   1. The cheapest variant's `inventory_quantity` (when `manage_inventory`
 *      is on and an InventoryItem exists — populated by the backend
 *      module link `Product↔StockLocation` once it ships).
 *   2. `metadata.stock_quantity` — legacy RadioLED importer.
 *   3. `metadata.stock` — new YML import pipeline (radar-online).
 *
 * Returns 0 when nothing is known — callers should render "on order".
 */
export function getProductStockQuantity(
  product: Pick<HttpTypes.StoreProduct, "variants" | "metadata">
): number {
  const variants = product.variants ?? []
  for (const v of variants) {
    if (
      v?.manage_inventory &&
      typeof v.inventory_quantity === "number" &&
      v.inventory_quantity > 0
    ) {
      return v.inventory_quantity
    }
  }
  const meta = (product.metadata ?? {}) as Record<string, unknown>
  const a = Number(meta.stock_quantity ?? 0)
  if (Number.isFinite(a) && a > 0) return a
  const b = Number(meta.stock ?? 0)
  if (Number.isFinite(b) && b > 0) return b
  return 0
}
